import { ReactNode } from 'react';
import { ICommon, IProject } from './common';

export enum WizardPhase {
	Build = 'build',
	Integrate = 'integrate',
	Customize = 'customize',
	Done = 'done'
}

export enum WizardMode {
	NotStarted = 'not_started',
	inProgress = 'in_progress',
	dismissed = 'dismissed'
}

export enum ArchType {
	B2C = 'b2c',
	MT = 'multiTenant'
}

export interface IWizardCombination {
	preset: string;
	previewImage: string;
	selected: boolean;
	primaryMethods: string[];
	secondaryMethod: string;
}

export interface IWizardFlow {
	id: string;
	title: string;
	description: string;
}

export interface IWizard extends ICommon, IProject {
	mode: `${WizardMode}` | '';
	phase: `${WizardPhase}` | '';
	page: string | '';
	archType: `${ArchType}` | '';
	primaryMethods: string[];
	secondaryMethod: string | '';
	combinations: IWizardCombination[];
	flows: IWizardFlow[];
	sampleApp: string | '';
	checklist: IWizardChecklist;
}

export const defaultWizardState: Partial<IWizard> = {
	mode: WizardMode.inProgress,
	phase: WizardPhase.Build,
	page: '',
	archType: '',
	primaryMethods: [],
	secondaryMethod: '',
	combinations: [],
	flows: [],
	sampleApp: '',
	checklist: {}
};

export interface IWizardProps {
	state: IWizard;
}

export interface IWizardAuthMethodItem {
	value: WizardAuthMethod;
	icon: any;
	subtitle: boolean;
	label: string;
	disabledOnSecondary?: boolean;
}

export enum WizardAuthMethod {
	SSO = 'sso',
	MagicLink = 'magiclink',
	EnchantedLink = 'enchantedlink',
	Biometrics = 'biometrics',
	Socials = 'socials',
	OTP = 'otp',
	TOTP = 'totp'
}

export interface IWizardChecklistItem {
	name: string;
	status: string;
}

export interface IWizardChecklistSection {
	name: string;
	items: IWizardChecklistItem[];
}

export interface IWizardChecklist {
	[index: string]: IWizardChecklistSection;
}

export interface IWizardActionsButtonsProps {
	actionButton: ReactNode;
	backButton?: ReactNode;
}
